import * as React from 'react';
import {Checkbox} from '@practicegenius/pg-ui/src/base/Material/components/Checkbox';
import {RegisterPasswordScreenType} from '@practicegenius/register-account/src/screens/RegisterPassword';
import {CreatePasswordInput} from '../../../components/CreatePasswordInput';
import {ProgressScreen} from '../../../components/screens/BaseScreen';

export const RegisterPassword: RegisterPasswordScreenType = ({
  lang,
  onFormSubmit,
  progress,
  actionButtons,
  userAccount,
  passwordInputProps,
  rememberMeCheckboxProps,
}) => {
  const onSubmit: typeof onFormSubmit = async e => {
    if (onFormSubmit) {
      return onFormSubmit(e);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <ProgressScreen
        helmetTitle={lang.pageTitle}
        headerTitle={lang.headerTitle}
        title={lang.title}
        instructions={lang.instructions}
        progress={progress}
        actionButtons={[actionButtons.primary]}
        cancelProps={{href: '/'}}
      >
        <CreatePasswordInput
          name="password"
          value={passwordInputProps.value ?? ''}
          onChange={e => passwordInputProps.onChange(e.target.value)}
          validate={passwordInputProps.onValidationError}
          error={passwordInputProps.error}
          user={userAccount}
          autoComplete="new-password"
          autoFocus
        />

        <Checkbox
          checked={rememberMeCheckboxProps.value}
          onChange={e => rememberMeCheckboxProps.onChange(e.target.checked)}
          label={lang.rememberMeCheckbox.label}
        />
      </ProgressScreen>
    </form>
  );
};
